export const isMobileWidth = () => {
  return window.innerWidth <= 480;
};

export const isTourCompatibleWidth = () => {
  return window.innerWidth >= 768;
};
